var map = {
	"./homepage.de-CH.json": 1448,
	"./homepage.de-DE.json": 1449,
	"./homepage.en-CA.json": 1450,
	"./homepage.en-GB.json": 1451,
	"./homepage.en-IN.json": 1452,
	"./homepage.en-ME.json": 1453,
	"./homepage.en-US.json": 1454,
	"./homepage.es-EM.json": 1455,
	"./homepage.es-ES.json": 1456,
	"./homepage.fr-BE.json": 1457,
	"./homepage.fr-CA.json": 1458,
	"./homepage.fr-CH.json": 1459,
	"./homepage.nl-BE.json": 1460,
	"./homepage.nl-NL.json": 1461,
	"./homepage.pl-PL.json": 1462,
	"./homepage.pt-BR.json": 1463
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1447;